import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ChangeProfileAndAddressModel, ChangeProfileAndAddressResponse } from '@digilize/shared/definitions/src';
import { LoginForm } from '@shared/definitions';

@Injectable({
  providedIn: 'root',
})
export class MeProfileService {
  private readonly http = inject(HttpClient);

  login = (loginForm: LoginForm, headers?: HttpHeaders) =>
    this.http.post('/api/v2.0/auth', loginForm, {
      headers,
      observe: 'response',
    });

  postProfileWithAdress = (req: ChangeProfileAndAddressModel) =>
    this.http.post<ChangeProfileAndAddressResponse>('/api/v1.0/me/profilewithaddress', req);
}
